import styled from '@emotion/styled';
import { Autocomplete, InputLabel, ListItemText, Radio, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { DistanceTableContainerStyle, FilterChildNameSharedStyle, MenuItemStyle, TableContainerStyle } from '../Filter.mock';
import { GroupsSelectInterface } from '../Filter.interface';

const TableContainer = styled.div(TableContainerStyle, DistanceTableContainerStyle);

const ModifiedSelect = ({ groupName, checkedEntity, onChangeHandler, totalEntities, labelFormatter }: GroupsSelectInterface) => {
  const [selectedValue, setSelectedValue] = useState('');

  const options = useMemo(() => totalEntities.map(({ code }) => code).filter((item) => !!item) as string[], [totalEntities]);

  const onInputHandler = (event: React.SyntheticEvent, value: string) => {
    event?.preventDefault();
    onChangeHandler(value);
  };

  const onSelectHandler = (event: React.SyntheticEvent, value: string | null) => {
    event?.preventDefault();
    if (value) onChangeHandler(value);
  };

  useEffect(() => {
    const [checkedValue] = checkedEntity;
    setSelectedValue(checkedValue ?? '');
  }, [checkedEntity]);

  return (
    <TableContainer>
      <InputLabel sx={FilterChildNameSharedStyle}>
        <b>{groupName}</b>
      </InputLabel>
      <Autocomplete
        freeSolo
        inputValue={selectedValue}
        size="small"
        options={options}
        renderInput={(params) => <TextField {...params} placeholder="Default 20 km" />}
        renderOption={(props, option) => (
          <li {...props} style={MenuItemStyle}>
            <Radio checked={checkedEntity.includes(option)} />
            <ListItemText primary={labelFormatter ? labelFormatter(option) : option} />
          </li>
        )}
        onInputChange={onInputHandler}
        onChange={onSelectHandler}
      />
    </TableContainer>
  );
};

export default ModifiedSelect;
